import React from 'react';
import LetterBlock from 'components/UI/LetterBlock/LetterBlock';
import './SoundTypes.module.scss';
import MultiKeyboardBlocks from '../MultiKeyboardBlocks/MultiKeyboardBlocks';

export default function LongSounds({ keyboard }: { keyboard?: boolean }) {
    return (
        <>
            <div styleName="row">
                <MultiKeyboardBlocks letters="aa">
                    <LetterBlock letter="a" soundType="long-sound" />
                    <LetterBlock letter="a" soundType="long-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ee">
                    <LetterBlock letter="e" soundType="long-sound" />
                    <LetterBlock letter="e" soundType="long-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="oo">
                    <LetterBlock letter="o" soundType="long-sound" />
                    <LetterBlock letter="o" soundType="long-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="uu">
                    <LetterBlock letter="u" soundType="long-sound" />
                    <LetterBlock letter="u" soundType="long-sound" />
                </MultiKeyboardBlocks>
            </div>
            {keyboard && (
                <div styleName="row">
                    <MultiKeyboardBlocks letters="a">
                        <LetterBlock letter="a" soundType="long-sound" />
                        <LetterBlock
                            letter="a"
                            soundType="long-sound"
                            grayedOut
                        />
                    </MultiKeyboardBlocks>
                    <MultiKeyboardBlocks letters="e">
                        <LetterBlock letter="e" soundType="long-sound" />
                        <LetterBlock
                            letter="e"
                            soundType="long-sound"
                            grayedOut
                        />
                    </MultiKeyboardBlocks>
                    <MultiKeyboardBlocks letters="o">
                        <LetterBlock letter="o" soundType="long-sound" />
                        <LetterBlock
                            letter="o"
                            soundType="long-sound"
                            grayedOut
                        />
                    </MultiKeyboardBlocks>
                    <MultiKeyboardBlocks letters="u">
                        <LetterBlock letter="u" soundType="long-sound" />
                        <LetterBlock
                            letter="u"
                            soundType="long-sound"
                            grayedOut
                        />
                    </MultiKeyboardBlocks>
                </div>
            )}
        </>
    );
}
